import { ArrowRight } from "lucide-react";
import { Eyebrow, Heading } from "./Section";
import { SERVICES } from "../data";

export const Services = () => (
  <section id="services" data-testid="services" className="py-20 md:py-28 bg-black">
    <div className="max-w-4xl mx-auto px-4 sm:px-6">
      <div className="mb-10">
        <Eyebrow>Services</Eyebrow>
        <Heading>WHAT YOU CAN BOOK</Heading>
      </div>

      <div className="divide-y divide-white/10 border-y border-white/10">
        {SERVICES.map((s) => (
          <a key={s.id} href={s.link} data-testid={`service-${s.id}`}
            className="group flex items-center justify-between gap-4 py-6 px-1 hover:bg-white/[0.03] transition-colors">
            <div className="min-w-0">
              <h3 className="font-display text-2xl md:text-3xl tracking-wide text-cream group-hover:text-barber-red transition-colors">
                {s.name}
              </h3>
              <p className="text-sm text-cream/55 font-body mt-1">{s.desc}</p>
            </div>
            <div className="text-right shrink-0">
              <div className="font-mono-u text-lg md:text-xl text-cream">{s.price}</div>
              <div className="font-mono-u text-[11px] tracking-widest uppercase text-cream/45 mt-1">{s.duration}</div>
              <span className="inline-flex items-center gap-1 mt-2 font-mono-u text-[10px] tracking-widest uppercase text-barber-red opacity-0 group-hover:opacity-100 transition-opacity">
                Book <ArrowRight size={12} />
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);
